package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initScholarshipPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Scholarship.md", FrontMatterElement.Builder { addScalar("title", "スカラーシップ制度"); addScalar("description", "Kotlin Fest 2026のスカラーシップ制度の募集は終了しました。たくさんのご応募をいただき、ありがとうございました。"); }))
}

@Page("/scholarship")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun ScholarshipPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("スカラーシップ制度の募集は終了しました") }) {
        org.jetbrains.compose.web.dom.Text("スカラーシップ制度の募集は終了しました")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("たくさんのご応募をいただき、ありがとうございました。")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin Fest 2026では、金銭的・地理的な制約を緩和し、学生の皆さまがカンファレンスへ参加しやすくなるよう、スカラーシップ制度を設けています。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("参加した学生がKotlin Festでの学びをもとに今後活躍し、身につけた知見をコミュニティに共有してくださることで「学びのループ」が生まれます。")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
        org.jetbrains.compose.web.dom.Text(" このループが、次世代の育成とKotlinコミュニティ・IT業界全体のさらなる発展に繋がると考えています。")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("h2") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s") {
            org.jetbrains.compose.web.dom.Text("""募集期間""")
        }
    }

    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s", attrs = {}) {
                org.jetbrains.compose.web.dom.Text("申し込み受付: 2026年7月1日（水）〜 2026年8月4日（火）")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s", attrs = {}) {
                org.jetbrains.compose.web.dom.Text("採択通知: 2026年8月中")
            }
        }
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("h2") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s") {
            org.jetbrains.compose.web.dom.Text("""応募方法""")
        }
    }

    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("p") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("s") {
            org.jetbrains.compose.web.dom.Text("""詳細は募集要項をご確認の上、応募フォームよりご応募ください。""")
        }
    }

    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("class", "markdown-button");attr("href", "https://docs.google.com/document/d/1QIhmiN9T7uVCNNC6saXh1N3F0Zc_t-P5yalxuYTuRcI/edit?usp=sharing")}) {
            org.jetbrains.compose.web.dom.Text("募集要項")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("a", attrs = {attr("class", "markdown-button");attr("aria-disabled", "true");attr("tabindex", "-1")}) {
            org.jetbrains.compose.web.dom.Text("応募フォーム")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("お問い合わせ") }) {
        org.jetbrains.compose.web.dom.Text("お問い合わせ")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("ご不明な点がございましたら、")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:contact@kotlinfest.dev") {
            org.jetbrains.compose.web.dom.Text("contact@kotlinfest.dev")
        }
        org.jetbrains.compose.web.dom.Text(" までご連絡ください。")
    }
}
